import { render, staticRenderFns } from "./DamageAssessorCaseEditLawyerModal.vue?vue&type=template&id=e1b4e442&scoped=true"
import script from "./DamageAssessorCaseEditLawyerModal.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseEditLawyerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b4e442",
  null
  
)

export default component.exports